import React from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";
import App from './App';
import {BrowserRouter, Route} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import { createStore, applyMiddleware} from 'redux'; 
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import api from "./api";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from './rootReducer';
import setUserAuthenticationToken from "./setUserAuthenticationToken";
import {userloggedIn} from "./components/UserIdentification/action";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk))); 
// axios.defaults.baseURL = 'http://localhost:8050';
setUserAuthenticationToken(localStorage.BookAppLogin);

if(localStorage.BookAppLogin){
    ReactDOM.render(<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>, document.getElementById("root"));
    api.user.getUserData().then(user => {
        store.dispatch(userloggedIn(user))
        ReactDOM.render(
            <BrowserRouter>
                <Provider store={store}>
                    <Route component={App}
                    />
                </Provider>
            </BrowserRouter>
            , 
            document.getElementById('root'));
    }).catch(msg => {
        localStorage.removeItem("BookAppLogin");
        ReactDOM.render(
            <BrowserRouter>
                <Provider store={store}>
                    <Route component={App}
                    />
                </Provider>
            </BrowserRouter>
            , 
            document.getElementById('root'));
    })
}else{
    ReactDOM.render(<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>, document.getElementById("root"));
    if (localStorage.loggouted) {
        api.user.logout().then(msg => {
            localStorage.removeItem("loggouted");
        })
    }
    ReactDOM.render(
            <BrowserRouter>
                <Provider store={store}>
                    <Route component={App}
                    />
                </Provider>
            </BrowserRouter>
            , 
            document.getElementById('root'));
}



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
